import List from "@/components/list";
import Bus from "./Bus.js";
const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function() {};
  const RCsortChange = args.listeners["sort-change"] || function() {};
    //测试成绩
    function test() {
      let i=1;
      i++;
      if(i%3==1){
       Bus.$emit("testResult", { sortName:"exam_score" , sortType: "desc" });
      } else if(i%3==2){
       Bus.$emit("testResult", { sortName: "exam_score", sortType: "asc" });
      } else{
       Bus.$emit("testResult", { sortName: "exam_score", sortType: "" });
      }
   }
  const AccountTableConfig = [
    {
      type: "selection",
      label: "main"
    },
    {
      label: "班组名称",
      prop: "groupName",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "学员姓名",
      prop: "userName",
      minWidth: "120"
    },
    {
      label: "工作单位",
      prop: "deptName",
      minWidth: "120"
    },
    {
      label: "单位及职务",
      prop: "unitPosition",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "等级",
      prop: "examGradeName",
      minWidth: "120",
      sortable: "custom",
      showOverflowTooltip: true,
    },
    {
      label: "测试成绩",
      prop: "examScore",
      minWidth: "120",
      sortable: true,
      showOverflowTooltip: true,
      render: vo => (
        <el-button
          size="small"
          type="text"
          onClick={() => test()}
        >
          {vo.row.examScore}
        </el-button>
      )
    }
  ];

  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      onSortChange={RCsortChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
